export type NotificationTone = "red" | "green" | "yellow" | "default";

export interface NotificationPresentation {
  title: string;
  tone: NotificationTone;
}

const CLIENT_RESPONDED = "client_responded";
const PROJECT_STATUS_CHANGED = "project_status_changed";
const READY_TO_START_TITLE = "ready to start";

const COMMENT_TYPES = [
  "comment_added",
  "new_comment",
  "reply_added",
  "new_reply",
];

const normalize = (value?: string | null) => (value || "").trim().toLowerCase();

// Single source for activity wording and icon tone so the dashboard and the notifications screen never drift.
export const resolveNotificationPresentation = (
  type?: string | null,
  title?: string | null,
): NotificationPresentation => {
  const notificationType = normalize(type);
  const displayTitle = title || "Activity";

  if (notificationType === CLIENT_RESPONDED) {
    return { title: "Client Feedback Received", tone: "red" };
  }

  if (COMMENT_TYPES.includes(notificationType)) {
    return { title: displayTitle, tone: "yellow" };
  }

  // "Ready to Start" and "Waiting for Designer" share one type, so the title is what separates them.
  if (
    notificationType === PROJECT_STATUS_CHANGED &&
    normalize(title) === READY_TO_START_TITLE
  ) {
    return { title: displayTitle, tone: "green" };
  }

  return { title: displayTitle, tone: "default" };
};

export default resolveNotificationPresentation;
